//
// RolesInspector.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "../../models/dataDefinition/DataItem";
import "./RoleName";

var RolesInspector = createModule("BIRD::RolesInspector", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        isRequired: [2],
        getLabel: [7],
        getName: [4],
        getDataItems: [[1]],
        isAllowMulti: [2],
    },
    ,
    ,
]);
export default RolesInspector;
